import $ from 'jquery';
import {
    $body,
    $document,
    isMobile,
    isNative,
    isAndroid,
    appVersion,
    isTouchDevice,
} from 'util/global';
import { getOrientation, repositionTooltip } from 'util/btooltip';
import { track } from 'util/analytics';
import { EVT_QUIZ_POSITION_WILL_CHANGE } from 'util/constants';
import 'jquery-ui/widgets/draggable';

// Use Android bridge for Android apps 4.2.0 <= version < 4.7.0.
const useAndroidBridge = (
    isAndroid
    && appVersion
    && appVersion.isGreaterThanOrEqualTo('4.2.0')
    && !appVersion.isGreaterThanOrEqualTo('4.7.0')
);

// class names
const hidden = 'hidden';
const dragged = 'dragged';
const glossary = 'glossary';
const glossaryTooltip = 'glossary-tooltip';
const glossaryContainer = 'glossary-container';

export function init($target) {
    const $term = $target;
    const glossarySlug = $term.data('tooltip');
    const $tooltip = $(`#glossary-${glossarySlug}`);
    let hideTimeout;
    let firstTime = true;

    // create a container for glossary cards for positioning
    let div = $('div.glossary-container');
    if (div.length === 0) {
        div = $('<div>').addClass(glossaryContainer);
        $body.append(div);
    }
    if (!$tooltip.parent().hasClass(glossaryContainer)) {
        $tooltip.detach().appendTo(div);
    }

    const hide = () => {
        $tooltip.addClass(hidden);
    };

    const hideWithDelay = () => {
        hideTimeout = setTimeout(() => {
            hide();
        }, 300);
    };

    const show = () => {
        const termString = $term.html();

        track('ui', {
            element_id: 'viewed_glossary_card',
            glossary_card_slug: glossarySlug,
            glossary_card_trigger_term: termString,
        });

        const height = $tooltip.height();
        if (isMobile || isNative) {
            // If using the bridge function, just tell Android to show the glossary card and Android
            // will handle it natively
            if (useAndroidBridge) {
                const $tooltipClone = $tooltip.clone();
                $tooltipClone.find('.admin-links, .close').remove();
                try {
                    window.Android.glossaryShowCard(glossarySlug, termString, $tooltipClone.html());
                    return;
                } catch (e) {
                    // ignore
                }
            }
            $tooltip.removeClass(hidden);
        } else {
            if ($tooltip.hasClass(dragged)) {
                $tooltip.on('mouseleave', hideWithDelay);
            }
            const topOffset = 3;
            const leftOffset = -45;
            const zOffset = 400;
            $tooltip.removeClass('left right top bottom')
                .addClass(getOrientation($term, $tooltip))
                .css(repositionTooltip({
                    $target: $term,
                    $tooltip,
                    topOffset,
                    leftOffset,
                    zOffset,
                    offsetMethod: 'offset',
                }))
                .removeClass(hidden)
                .removeClass(dragged);
            if (height !== $tooltip.height()) {
                $tooltip.css(repositionTooltip({
                    $target: $term,
                    $tooltip,
                    topOffset,
                    leftOffset,
                    zOffset,
                    offsetMethod: 'offset',
                }));
            }
        }
    };

    if (isMobile || isNative) {
        $term.on('click', () => {
            if ($tooltip.hasClass(hidden)) {
                $('.glossary-tooltip').addClass(hidden);
                show();
                if (firstTime) {
                    firstTime = false;
                    $tooltip.find('button.close').on('click', hide);
                }
            } else {
                hide();
            }
        });
    } else if (isTouchDevice) {
        $term.on('click', () => {
            show();
            if (firstTime) {
                firstTime = false;
                $tooltip.draggable();
            }
        });
        $body.css({ cursor: 'pointer' });
        $document.on('click', (event) => {
            if (!$(event.target).hasClass(glossary) && !$(event.target).hasClass(glossaryTooltip)) {
                hide();
            }
        });

        $tooltip.on('dragstart', () => {
            $tooltip.off('mouseleave');
            $tooltip.addClass(dragged);
            $tooltip.find('button.close').on('click', hide);
        });
    } else {
        $term.on('mouseenter', () => {
            clearTimeout(hideTimeout);
            show();
            if (firstTime) {
                firstTime = false;
                $tooltip.draggable();
            }
        });
        $term.on('mouseleave', hideWithDelay);
        $tooltip.on('mouseenter', () => clearTimeout(hideTimeout));
        $tooltip.on('mouseleave', hideWithDelay);
        $tooltip.on('dragstart', () => {
            $tooltip.off('mouseleave');
            $tooltip.addClass(dragged);
            $tooltip.find('button.close').on('click', hide);
        });
    }

    $body.on(EVT_QUIZ_POSITION_WILL_CHANGE, hide);
}
